<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="750px">
      <c-card class="white" :title="this.roleData ? '권한 상세 정보' : '권한 등록'">

      <!-- info detail -->
        <v-row v-if="roleDataId">
          <v-row>
            <v-col cols="12" md="2">
              <span>권한명</span>
            </v-col>
            <v-col cols="12" md="10">
              <span class="font-weight-bold black--text">{{ roleData ? roleData.name : '-' }}</span>
            </v-col>
            <v-col cols="12" md="2">
              <span>기본 화면</span>
            </v-col>
            <v-col cols="12" md="10">
              <span class="font-weight-bold black--text">{{ roleData ? roleData.defaultRoutePath : '-' }}</span>
            </v-col>
            <v-col cols="12" md="2">
              <span>권한 메뉴 목록</span>
            </v-col>
            <v-col cols="12" md="10">
              <c-card outlined>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                    <tr
                        v-for="routeObject in routeObjectList" class="mt-3 mb-3"
                    >
                      <td>
                        <span class="font-weight-bold black--text">{{ routeObject.categoryName }}</span>
                      </td>
                      <td>
                        <div v-for="subRoute in routeObject.subRouteName" style="margin-top: 5px; margin-bottom: 5px;">{{ subRoute }}</div>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </c-card>
            </v-col>
          </v-row>
        </v-row>


      <!-- data insert -->
        <v-row v-else>
          <v-col cols="12" md="2">
            <span>권한명</span>
          </v-col>
          <v-col cols="12" md="10">
            <v-text-field v-model="name" placeholder="권한 이름을 입력해주세요" solo required :rules="[v => !!v]"
                          maxlength="32" hide-details clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <span>메뉴</span>
          </v-col>
          <v-col cols="12" md="10">
            <c-card outlined>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                  <tr
                      v-for="centerRole in centerRoleList"
                  >
                    <td>{{ centerRole.categoryName }}</td>
                    <td>
                      <v-checkbox
                          v-for="subRoute in centerRole.subRouteName"
                          :label="subRoute"
                          :value="{categoryName: centerRole.categoryName, subRouteName: subRoute}"
                          v-model="selectedMenu"
                          dense
                          class="py-0"
                      ></v-checkbox>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </c-card>
          </v-col>
          <v-col cols="12" md="2">
            <span>기본 화면</span>
          </v-col>
          <v-col cols="12" md="10">
            <v-select
                v-model="subRouteData"
                :items="selectedMenu"
                item-text="subRouteName"
                item-value="subRouteName"
                solo
                menu-props="{ offsetY: true}"
                hide-details
                label="기본 화면을 선택해주세요."
            ></v-select>
          </v-col>
        </v-row>




        <v-row justify="center">
          <c-btn v-if="roleDataId" class="mt-4 mr-1" color="red" outlined @click="onDeleteRole">삭제</c-btn>
          <c-btn v-else class="mr-1 mt-4" color="blue" outlined @click="onAddRole">저장</c-btn>
          <c-btn class="mt-4" outlined color="grey" @click="openFlag = false">{{ this.roleData ? '확인' : '취소'}}</c-btn>
        </v-row>

      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    roleDataId: {
      type: String,
    }
  },
  data: () => ({
    openFlag: false,

    name: '',
    selectedMenu: [],
    subRouteData: '',

    centerRoleList: [],
    routeObjectList: [],

    roleData: {},
  }),
  watch: {
    open(value) {
      this.openFlag = value;
      if (value && !this.roleDataId){
        // Insert
        this.initData();
        this.reqGetCenterRoleList();
      } else if (value && this.roleDataId) {
        // Detail
        this.routeObjectList = [];
        this.reqGetRole(this.roleDataId);
      }
    },
    openFlag(value) {
      this.$emit('update:open', value);
    }
  },
  methods: {
    async reqGetCenterRoleList() {
      try {
        const res = await this.$api.getCenterRouteList();
        this.centerRoleList = res.data;

      } catch (err) {
        this.openFlag = false;
        this.$store.commit('snackbar', {err, where: 'reqGetCenterRoleList'});
      }
    },
    initData() {
      this.name = '';
      this.selectedMenu = [];
      this.subRouteData = '';
      this.roleData = null;
    },
    onAddRole() {
      if (!this.name) {
        this.$store.commit('snackbar', {timeout: 2000, msg: '권한 이름을 입력해주세요.'});
        return;
      }

      if (this.selectedMenu.length < 1) {
        this.$store.commit('snackbar', {timeout: 2000, msg: '하나 이상의 메뉴를 선택해주세요.'});
        return;
      }

      if (!this.subRouteData) {
        this.$store.commit('snackbar', {timeout: 2000, msg: '기본 메뉴 화면을 선택해주세요.'});
        return;
      }

      let reqData = {
        name: this.name,
        defaultRoutePath: this.subRouteData,
        categoryName: [...new Set(this.selectedMenu.map(item => item.categoryName))].join(','),
        subRouteName: this.selectedMenu.map(item => item.subRouteName).join(','),
      }

      this.$emit('reqAddRole', reqData);
    },
    onDeleteRole() {
      this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "이 관리자 권한을 삭제하시겠습니까?",
            confirm: true, callBack: () => {
              this.reqDeleteRole();
            }
          });
    },
    async reqDeleteRole() {
      try {
        const res = await this.$api.deleteAdminRole(this.roleDataId);
        this.$store.commit('snackbar', {color:'blue', msg: '삭제가 완료되었습니다.'});
        this.openFlag = false;

        this.$emit('reqGetRoleList')
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'reqDeleteRole'});
      }
    },
    async reqGetRole(id) {
      try {
        const res = await this.$api.getAdminRoleById(id);
        this.roleData = res.data;

        const categoryName = this.roleData.categoryName;
        const subRouteName = this.roleData.subRouteName;

        // 접근 가능 메뉴 리스트 필터링 (category[subRoute])
        let routes = require(process.env.VUE_APP_ROUTES);
        let usageRoutes = routes.default.filter(item => !(item.type === 'hidden'));//todo app에서 나무센터 fix이므로 개발환경에서는 메뉴가 보여야함.

        usageRoutes.forEach(item => {
          let routeObject = {};
          if(categoryName.includes(item.name)) {
            routeObject['categoryName'] = item.name;
            if(!!item.subRoutes) {
              let subRouteNameList = [];
              item.subRoutes.forEach(subItem => {
                if(subRouteName.includes(subItem.name)) subRouteNameList.push(subItem.name);
              })
              routeObject['subRouteName'] = subRouteNameList;
            }
          }
          if(!Object.keys(routeObject).length == 0)this.routeObjectList.push(routeObject);
        })
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'reqGetRole'});
      }
    },
  },

}
</script>

<style scoped>

</style>